/**
 * @ngdoc directive
 * @name menu
 *
 * @description
 * Page breadcrumbbreadcrumb
 */
module.directive('breadcrumb', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            breadcrumb: '=list'
        },
        template:
                '<nav class="aqua-breadcrumb">' +
                '  <p class="grid-main">' +
                '    <span ng-repeat="crumb in breadcrumb track by $index" class="aqua-breadcrumb--item">' +
                '      <span ng-if="crumb.state"><a ui-sref="{{crumb.state}}" class="aqua-breadcrumb--link">{{crumb.label}}</a></span>' +
                '      <span ng-if="!crumb.state">{{crumb.label}}</span>' +
                '      <span ng-if="!$last"> &gt;</span>' +
                '    </span>' +
                '  </p>' +
                '</nav>'
    };
});